export default __webpack_public_path__ + "static/media/thumb-IVTS-6.d41c3ebb.png";